import { useStoreTheme } from '@/store'
import { useCallback } from 'react'

const useSetTheme = () => {
  const theme = useStoreTheme.use.theme()
  const setTheme = useStoreTheme.use.setTheme()
  const themeClick = useStoreTheme.use.themeClick()
  const setThemeClick = useStoreTheme.use.setThemeClick()

  const handleSetTheme = useCallback(() => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
    setThemeClick(!themeClick)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeClick])

  return handleSetTheme
}

export default useSetTheme
